import { motion } from "motion/react";
import { useTranslation } from 'src/lib/i18n/useTranslation';
import { Offscreen } from 'src/lib/common/ui/Offscreen';
import { ErrorScreen } from 'src/lib/common/ui/ErrorScreen';
import { useResultsViewModel } from './resultsViewModel';
import { ResultsLoadingScreen } from './ResultsLoadingScreen';
import { ResultsDataWarning } from "./ResultsDataWarning";
import { ProductList } from './ProductList';
import { ArrowLeft } from 'src/lib/assets/icons';
import styles from './ResultsPage.module.scss';

export function ResultsPage() {
  const { t } = useTranslation();
  const viewModel = useResultsViewModel();

  if (viewModel.error) {
    return <ErrorScreen error={ viewModel.error } />;
  }

  const canSearch = viewModel.canSearch;
  if(!canSearch) {
    return <ResultsDataWarning />;
  }

  if (viewModel.isLoading) {
    return <ResultsLoadingScreen />;
  }

  const prevButtonClick = () => {
    viewModel.goToPreviousStep();
  };

  const resetButtonClick = () => {
    viewModel.resetWizard();
  };

  return (
    <motion.div initial={{  opacity: 0 }} animate={{  opacity: 1 }} exit={{  opacity: 0 }} transition={{ duration: 0.3 }}>
      <div className={ styles.container }>

        {/* content */}
        <motion.div className={ styles.contentBlock } initial={{  opacity: 0 }} animate={{  opacity: 1 }} transition={{ duration: 0.5 }}>
          <div className={ styles.contentBlockInner }>

            <header className={ styles.header }>
              <h1 className={ styles.title }>
                { t('results_title') }
              </h1>
            </header>

            <div className={ styles.content }>
              <ProductList products={ viewModel.results } />
            </div>

          </div>
        </motion.div>
        {/* /content */}

        {/* actions */}
        <motion.div className={ styles.actionBlock } initial={{ translateY: '5rem', opacity: 0 }} animate={{ translateY: '0', opacity: 1 }} transition={{ duration: 0.4 }}>
          <div className={ styles.actionBlockInner }>

            <div className={ styles.actions }>
              <button type="button" className={ styles.ctaPrevious } onClick={ prevButtonClick }>
                <Offscreen>
                  { t('wizard_previous_step') }
                </Offscreen>
                <ArrowLeft />
              </button>
              <button type="submit" className={ styles.ctaReset } onClick={ resetButtonClick }>
                { t('wizard_reset') }
              </button>
            </div>

          </div>
        </motion.div>
        {/* /actions */}

      </div>
    </motion.div>
  );
}
